import { Send, Sparkles, BookOpen } from "lucide-react";
import profAvatar from "@/assets/Prof_1.webp";

const messages = [
  { role: "user" as const, content: "Explique-moi la photosynthèse simplement 🌿" },
  {
    role: "ai" as const,
    lines: [
      "Super question ! 🌱 La photosynthèse, c'est la magie des plantes !",
      "Imagine que les plantes sont des cuisines solaires :",
      "☀️ Soleil = énergie  |  💧 Eau = ingrédient  |  🌫️ CO₂ = ingrédient 2",
      "→ Résultat : Sucre (nourriture) + Oxygène (l'air qu'on respire !)",
      "Tu veux que j'explique chaque étape en détail ?",
    ],
  },
  { role: "user" as const, content: "Aide-moi à résoudre : 2x + 5 = 13 📐" },
  {
    role: "ai" as const,
    lines: [
      "Parfait, je vais t'expliquer étape par étape ! 📐",
      "Étape 1 : Soustraire 5 des deux côtés",
      "2x + 5 - 5 = 13 - 5  →  2x = 8",
      "Étape 2 : Diviser par 2",
      "2x ÷ 2 = 8 ÷ 2  →  x = 4 ✅",
      "Tu veux essayer un exercice similaire pour t'entraîner ?",
    ],
  },
];

const ChatPreview = () => {
  return (
    <section id="chat-preview" className="py-24 bg-muted/40">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <div className="badge-new inline-flex mb-4"><span>💬</span><span>IA conversationnelle</span></div>
          <h2 className="section-title">Discute avec ton <span className="text-gradient">professeur IA</span></h2>
          <p className="section-subtitle mt-4">Pose n'importe quelle question. L'IA explique simplement et t'accompagne pas à pas.</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="card-edu overflow-hidden" style={{ boxShadow: "var(--shadow-md)" }}>
            {/* Header */}
            <div className="px-6 py-4 flex items-center gap-3" style={{ background: "var(--gradient-hero)" }}>
              <img src={profAvatar} alt="KelasAI" className="w-10 h-10 rounded-2xl object-cover" />
              <div>
                <p className="font-black text-white text-sm">KelasAI Assistant</p>
                <div className="flex items-center gap-1.5">
                  <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                  <p className="text-white/80 text-xs font-semibold">En ligne · Prêt à t'aider</p>
                </div>
              </div>
              <Sparkles className="w-5 h-5 text-white/70 ml-auto" />
            </div>

            {/* Messages */}
            <div className="p-6 flex flex-col gap-5 max-h-96 overflow-y-auto bg-background/50">
              {messages.map((msg, i) => (
                <div key={i} className={`flex gap-3 ${msg.role === "user" ? "flex-row-reverse" : "flex-row"}`}>
                  <div className="w-9 h-9 rounded-2xl flex items-center justify-center text-lg flex-shrink-0" style={{ background: msg.role === "user" ? "hsl(var(--primary) / 0.12)" : "var(--gradient-hero)" }}>
                    {msg.role === "user" ? "👦" : <img src={profAvatar} alt="KelasAI" className="h-full w-full rounded-2xl object-cover" />}
                  </div>
                  <div className={`max-w-xs md:max-w-sm px-4 py-3 rounded-3xl text-sm font-medium leading-relaxed ${msg.role === "user" ? "rounded-tr-sm text-white" : "rounded-tl-sm text-foreground"}`} style={{ background: msg.role === "user" ? "var(--gradient-hero)" : "hsl(var(--muted))", boxShadow: msg.role === "user" ? "var(--shadow-primary)" : "none" }}>
                    {"content" in msg ? (
                      <p>{msg.content}</p>
                    ) : (
                      <div className="flex flex-col gap-1">
                        {msg.lines.map((line, li) => <p key={li}>{line}</p>)}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="px-6 py-4 border-t border-border bg-card">
              <div className="flex items-center gap-3 bg-muted rounded-2xl px-4 py-3">
                <BookOpen className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                <input type="text" placeholder="Pose ta question à KelasAI..." className="flex-1 bg-transparent text-sm font-medium text-foreground placeholder:text-muted-foreground outline-none" readOnly />
                <button type="button" aria-label="Envoyer la question" className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "var(--gradient-hero)" }}>
                  <Send className="w-4 h-4 text-white" />
                </button>
              </div>
              <p className="text-xs text-muted-foreground text-center mt-2 font-medium">💡 Version gratuite : 7 questions par jour</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChatPreview;
